'use client';

import LogoSvg from '@/app/_assets/logos/logo.svg';
import { SmartLink } from '@/app/_components/core/smart-link';
import { useLabel } from '@/app/_contexts/labels-context';
import { cn } from '@/app/_lib/utils';
import { LogoProps } from './logo.types';

export default function Logo({
  href = '/',
  className = 'w-auto',
}: LogoProps) {
  const ariaLabel = useLabel('goToHomepageAriaLabel', 'Go to homepage');

  return (
    <SmartLink href={href} className="flex items-center" aria-label={ariaLabel} data-track-id="header-logo">
      <LogoSvg className={cn(className, 'text-foreground')} />
    </SmartLink>
  );
}

export { Logo };
